// extracted by css-extract-rspack-plugin
export default {"cls1":"SortPanel-cls1_aS0","cls2":"SortPanel-cls2_38w SortPanel-cls1_aS0"};